import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card border-0 shadow-none rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4 p-xl-40" }
const _hoisted_3 = { class: "intro-card mb-4" }
const _hoisted_4 = { class: "mb-1" }
const _hoisted_5 = { class: "mb-0 text-muted" }
const _hoisted_6 = { class: "row g-3" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "field-group" }
const _hoisted_9 = { class: "field-label" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "field-group" }
const _hoisted_13 = { class: "field-label" }
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "permission-toolbar mt-4 mb-4" }
const _hoisted_16 = { class: "checkbox style-four" }
const _hoisted_17 = ["checked"]
const _hoisted_18 = {
  class: "form-check-label fw-semibold",
  for: "select_all"
}
const _hoisted_19 = { class: "permission-hint" }
const _hoisted_20 = { class: "row g-4" }
const _hoisted_21 = { class: "permission-card" }
const _hoisted_22 = { class: "permission-card__header" }
const _hoisted_23 = { class: "mb-0" }
const _hoisted_24 = { class: "permission-card__body" }
const _hoisted_25 = { class: "checkbox style-four" }
const _hoisted_26 = ["id", "onUpdate:modelValue"]
const _hoisted_27 = ["for"]
const _hoisted_28 = { class: "row mt-4" }
const _hoisted_29 = { class: "col-12" }
const _hoisted_30 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "intro-icon" }, [
            _createElementVNode("i", { class: "ri-shield-keyhole-line" })
          ], -1)),
          _createElementVNode("div", null, [
            _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.$t("group_permission_page.create_header")), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("group_permission_page.create_description")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("group_permission_page.role_name")), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control field-input",
                placeholder: _ctx.$t('group_permission_page.role_name_placeholder'),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.role.role_name) = $event)),
                required: ""
              }, null, 8, _hoisted_10), [
                [_vModelText, _ctx.role.role_name]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("group_permission_page.description_label")), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control field-input",
                placeholder: _ctx.$t('group_permission_page.description_placeholder'),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.role.description) = $event))
              }, null, 8, _hoisted_14), [
                [_vModelText, _ctx.role.description]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              id: "select_all",
              checked: _ctx.isAllSelected,
              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleAll && _ctx.toggleAll(...args)))
            }, null, 40, _hoisted_17),
            _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("group_permission_page.select_all_permissions")), 1)
          ]),
          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("group_permission_page.toggle_hint")), 1)
        ]),
        _createElementVNode("div", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localizedPermissionGroups, (group, gIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: gIndex,
              class: "col-xl-4 col-lg-6"
            }, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("h6", _hoisted_23, _toDisplayString(group.name), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.permissions, (perm, pIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: pIndex,
                      class: "permission-item"
                    }, [
                      _createElementVNode("div", _hoisted_25, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          id: `permission-${gIndex}-${perm.key}`,
                          "onUpdate:modelValue": ($event: any) => ((_ctx.role[perm.key]) = $event),
                          "true-value": 1,
                          "false-value": 0
                        }, null, 8, _hoisted_26), [
                          [_vModelCheckbox, _ctx.role[perm.key]]
                        ]),
                        _createElementVNode("label", {
                          class: "form-check-label",
                          for: `permission-${gIndex}-${perm.key}`
                        }, _toDisplayString(perm.label), 9, _hoisted_27)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("button", {
              class: "btn style-one px-4 h-55",
              type: "submit",
              disabled: _ctx.isSubmitting
            }, _toDisplayString(_ctx.isSubmitting ? _ctx.$t("group_permission_page.creating") : _ctx.$t("group_permission_page.create_role")), 9, _hoisted_30)
          ])
        ])
      ], 32)
    ])
  ]))
}